import Titulo from '../../components/tipografia/Titulo';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import styles from './page.module.css';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Descricao from '../../components/tipografia/Descricao';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import BotaoDropdown from '../../components/BotaoDropdown';
import VBox from '../../components/layout/VBox';
import CampoTexto from '../../components/Formulario/CampoTexto';
import Icon from '../../components/Icon';
import {
  mdiAccountCreditCard,
  mdiContentSave,
  mdiDelete,
  mdiDeleteCircle,
  mdiDownload,
  mdiEye,
  mdiFileDelimited,
  mdiLoading,
  mdiMagnify,
  mdiOfficeBuilding,
  mdiPen,
  mdiPlus,
  mdiStar,
  mdiDotsVertical,
  mdiTrashCan,
  mdiUpload,
} from '@mdi/js';
import DataTable, { DataTableHeader } from '../../components/layout/DataTable';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import axios from 'axios';
import BotaoPerigoso from '../../components/BotaoPerigoso';
import { useDebounce } from '../chat/useDebounce';
import { toast } from 'react-toastify';
import Modal from '../../components/layout/Modal';
import { FormCliente } from './FormCliente';
import Grid, { GridItem } from '../../components/layout/Grid';
import CampoMultiSeletor from '../../components/Formulario/CampoMultiSeletor';
import Badge from '../../components/layout/Badge';
import { parseISO, format, set } from 'date-fns';
import { Tooltip } from '../../components/layout/Tooltip';
import CampoNumero from '../../components/Formulario/CampoNumero';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import IconeCanal from '../../components/layout/IconeCanal';
import AlertBox from '../../components/layout/AlertBox';
import Marcadores from '@/components/layout/Marcadores';
import CampoCheckbox from '@/components/Formulario/CampoCheckbox';
import { CampoPersonalizacao } from '@/components/Formulario/CampoPersonalizacao';
import Subtitulo from '@/components/tipografia/Subtitulo';
import Card from '@/components/layout/Card';
import Conversas from '../chat/Conversas';
import Mensagens from '../chat/Mensagens';
import Mensagem from '../chat/Mensagem';
import { ChatMensagemDto } from '@tera/shared/src/dto/ChatMensagemDto';
import CampoMultiTexto from '@/components/Formulario/CampoMultiTexto';
import CampoMemo from '@/components/Formulario/CampoMemo';
import ViewCliente from './ViewCliente';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { render } from '@testing-library/react';
import CampoUpload from '@/components/Formulario/CampoUpload';
import FreeTierModal from '@/components/FreeTierModal';

type ResponseList = {
  status: number;
  ok?: boolean;
  result: any[];
  total: number;
  cursor: string | number | null;
};

type Props = {};

const TextoPersonalizacao = ({ type, value }: any) => {
  if (value === null || value === undefined || value === '') return '-';

  switch (type) {
    case 'data':
      return format(parseISO(value), 'dd/MM/yyyy');
    case 'booleano':
      return value ? 'Sim' : 'Não';
    case 'lista':
      return value && Array.isArray(value) ? value.join(', ') : value ?? '-';
    default:
      return value;
  }
};

const Page = ({ }: Props) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const capacidadesQuery = useQuery(
    ['capacidades'],
    async () => {
      const res = await axios.get('/api/capacidades', {
        withCredentials: true,
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30000, // 30 segundos
    }
  );

  const [editObject, setEditObject] = React.useState<any>(null);
  const [fieldErrors, setFieldErrors] = React.useState<Record<
    string,
    string
  > | null>(null);

  const [clientInfo, setClientInfo] = React.useState<any>(null);

  const [search, setSearch] = React.useState<string>('');
  const debouncedSearch = useDebounce(search, 500);

  const [filterStatus, setFilterStatus] = React.useState<string[]>([]);
  const [filterClienteGrupo, setFilterClienteGrupo] = React.useState<string[]>(
    [],
  );

  const [showImportModal, setShowImportModal] = React.useState(false);
  const [importResults, setImportResults] = React.useState<any>(null);
  const [showFreeTierModal, setShowFreeTierModal] = React.useState(false);

  const [ddd, setDdd] = React.useState<string | null>(null);
  const [clienteEstado, setClienteEstado] = React.useState<string | null>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [file, setFile] = React.useState<File | null>(null);

  // WhatsApp Import state
  const [showImportWhatsappModal, setShowImportWhatsappModal] = React.useState(false);
  const [waFiles, setWaFiles] = React.useState<File[]>([]);
  const [waCanalId, setWaCanalId] = React.useState<string | null>(null);
  const waFormRef = useRef<HTMLFormElement>(null);
  const [waImportResults, setWaImportResults] = React.useState<any>(null);

  // Export Chats state
  const [showExportChatsModal, setShowExportChatsModal] = React.useState(false);
  const [exportMode, setExportMode] = React.useState<'all' | 'selected'>('all');
  const [selectedClientesToExport, setSelectedClientesToExport] = React.useState<number[]>([]);
  const [exportJobId, setExportJobId] = React.useState<number | null>(null);
  const [exportJobStatus, setExportJobStatus] = React.useState<'idle' | 'pendente' | 'processando' | 'concluido' | 'erro'>('idle');
  const [exportJobProgress, setExportJobProgress] = React.useState(0);
  const [exportJobError, setExportJobError] = React.useState<string | null>(null);
  const exportPollRef = React.useRef<ReturnType<typeof setInterval> | null>(null);

  const stopExportPoll = React.useCallback(() => {
    if (exportPollRef.current) {
      clearInterval(exportPollRef.current);
      exportPollRef.current = null;
    }
  }, []);

  const triggerExportDownload = React.useCallback(async (jobId: number, filename?: string) => {
    try {
      const resp = await axios.get(`/api/chat/export/${jobId}/download`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename ?? `export-chats-${new Date().toISOString().split('T')[0]}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast('Conversas exportadas com sucesso!', { type: 'success', position: 'top-center' });
    } catch {
      toast('Export concluído mas falhou ao baixar o arquivo.', { type: 'error', position: 'top-center' });
    }
  }, []);

  const canaisQuery = useQuery('canais/box', async () => {
    const res = await fetch('/api/canal/box');
    return res.json();
  });
  const canaisWhatsapp = (canaisQuery.data?.result ?? [])
    .filter((c: any) => ['whatsapp', 'wa360'].includes(c.tipo))
    .map((c: any) => ({ id: String(c.id), label: `${c.nome} (${c.tipo})` }));

  const importMutator = useMutation(async () => {
    if (!file) {
      alert('Nenhum arquivo selecionado.');
      return;
    }

    setImportResults(null);

    const formData = new FormData();
    formData.append('ddd', ddd!);
    formData.append('file', file as Blob);
    formData.append('cliente_estado', clienteEstado!);

    const extension = file!.name.split('.').pop();
    if (!['vcf', 'csv'].includes(extension!)) {
      alert('Formato de arquivo inválido.');
      return;
    }

    try {
      const response = await axios.post(`/api/cliente/upload/${extension}`, formData);

      setImportResults(response.data);

      queryList.refetch();
    } catch (error: any) {
      console.error(error);

      if (error.response?.data?.fieldErrors) {
        alert(error.response.data.msg ?? 'Erro ao importar arquivo');
      }
      throw error;
    } finally {
      setFile(null);
    }
  });

  const handleImportStart = async () => {
    importMutator.mutate();
  };

  const handleFileChange = (files: File[]) => {
    const selectedFile = files[0];
    setFile(selectedFile);
  };

  const qTags = useQuery('tags', async () => {
    const result = await axios.get('/api/marcador/box');
    return result.data?.result;
  });

  const qGrupos = useQuery('cliente_grupo/box', async () => {
    const { data } = await axios.get('/api/cliente_grupo/box');
    return data?.result ?? [];
  });
  const gruposOptions = qGrupos.data?.result?.map((it: any) => ({
    id: it.id,
    label: it.nome,
  }));

  const [showCustomizeModal, setShowCustomizeModal] = React.useState(false);
  const qCustomize = useQuery(
    'cliente/meta',
    async () => {
      const res = await axios.get('/api/cliente/meta', {
        withCredentials: true,
      });

      return res.data.result;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  const headersMeta =
    qCustomize.data
      ?.filter((it: any) => it.listavel)
      ?.map((it: any) => ({
        label: it.rotulo,
        render: (row: any) => {
          return (
            <TextoPersonalizacao
              type={it.tipo}
              value={row.metadados?.[it.nome]}
            />
          );
        },
      })) ?? [];

  const headers: DataTableHeader[] = useMemo(
    () => [
      { label: '#', width: '80px', column: 'id' },
      { label: 'Nome', width: '25%', column: 'nome' },
      { label: 'Empresa', width: '25%', render: (row: any) => row.empresa?.nome_fantasia ?? row.empresa?.razao_social ?? '-' },
      { label: 'Grupo', width: '25%', render: (row: any) => row.grupo?.nome },
      {
        label: 'Situação',
        width: '10%',
        render: (row: any) => {
          switch (row.estado) {
            case 'ativo':
              return (
                <Tooltip
                  position="bottom"
                  text="Recebe campanhas e notificações"
                >
                  <Badge style={{ width: 'fit-content' }} variant="success">
                    Ativo
                  </Badge>
                </Tooltip>
              );

            case 'inativo':
              return (
                <Tooltip position="bottom" text="Não interage com o sistema">
                  <Badge style={{ width: 'fit-content' }} variant="secondary">
                    Inativo
                  </Badge>
                </Tooltip>
              );
            case 'bloqueado':
              return (
                <Tooltip
                  position="bottom"
                  text="Não recebe campanhas nem notificações"
                >
                  <Badge style={{ width: 'fit-content' }} variant="danger">
                    Bloqueado
                  </Badge>
                </Tooltip>
              );
            case 'bloqueado_campanha':
              return (
                <Tooltip position="bottom" text="Recebe apenas notificações">
                  <Badge style={{ width: 'fit-content' }} variant="warning">
                    Bloq Campanhas
                  </Badge>
                </Tooltip>
              );
            default:
              return (
                <Badge style={{ width: 'fit-content' }} variant="secondary">
                  {row.estado}
                </Badge>
              );
          }
        },
      },
      {
        label: 'Marcadores',
        width: '10%',
        render: (row: any) => (
          <div>
            <Marcadores ids={row.marcadores?.map((it: any) => it.id)} />
          </div>
        ),
      },
      {
        label: 'Criado em',
        width: '30%',
        render: (row: any) => (
          <span style={{ whiteSpace: 'nowrap' }}>
            {format(parseISO(row.data_criacao), 'dd/MM/yyyy HH:mm')}
          </span>
        ),
      },
      ...headersMeta,
      {
        label: 'Ações',
        width: '100px',
        stickRight: true,
        alignRight: true,
        render: (row: any) => {
          return (
            <HBox gap="8px">
              <Botao
                title="Ver"
                variant="none-info"
                icon={mdiEye}
                onClick={() => setClientInfo(row)}
              />
              <Botao
                title="Editar"
                variant="none-primary"
                icon={mdiPen}
                onClick={() => setEditObject(row)}
              />
              <BotaoPerigoso
                buttonProps={{ title: 'Apagar' }}
                variant="none-danger"
                icon={mdiTrashCan}
                onClick={() => handleDelete(row.id)}
              />
            </HBox>
          );
        },
      },
    ],
    [qTags.data, headersMeta],
  );

  const queryList = useInfiniteQuery({
    queryKey: ['cliente'],
    queryFn: async ({ pageParam }) => {
      const filter: Record<string, any> = {};

      if (filterStatus.length > 0) {
        filter['estado'] = ['in', filterStatus];
      }

      if (filterClienteGrupo.length > 0) {
        filter['grupo_id'] = ['in', filterClienteGrupo.map(Number)];
      }

      const params = new URLSearchParams({
        txt: debouncedSearch,
        c: pageParam ?? '',
        fi: JSON.stringify(filter),
        ids: searchParams.getAll('ids').join(','),
      });

      return await axios.get<ResponseList>(
        `/api/cliente?${params.toString()}`,
        {
          withCredentials: true,
        },
      );
    },
    getNextPageParam: lastPage => lastPage.data.cursor ?? undefined,
  });

  const changeMutator = useMutation(
    async () => {
      if (!editObject) return;

      setFieldErrors(null);
      if (editObject.id) {
        return await axios.put(`/api/cliente/${editObject.id}`, editObject, {
          withCredentials: true,
        });
      } else {
        return await axios.post(`/api/cliente`, editObject, {
          withCredentials: true,
        });
      }
    },
    {
      onSuccess: () => {
        setFieldErrors(null);
        queryList.refetch();
        setEditObject(null);

        toast(!editObject.id ? 'Contato adicionado com sucesso' : 'Contato alterado com sucesso', {
          toastId: !editObject.id ? 'add-success' : 'edit-success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: (err: any) => {
        if (err.response?.status === 422) {
          setFieldErrors(err.response?.data?.fieldErrors ?? {});
        }
        toast(err.response?.data?.msg ?? 'Erro desconhecido', {
          toastId: !editObject.id ? 'add-error' : 'edit-error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
    },
  );

  const deleteMutator = useMutation(
    async (id: number) => {
      return await axios.delete(`/api/cliente/${id}`, {
        withCredentials: true,
      });
    },
    {
      onSuccess: () => {
        toast('Contato apagado com sucesso', {
          toastId: 'del-success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: (err: any) => {
        console.error(err);
        toast('Ocorreu um erro ao tentar apagar o contato.', {
          toastId: 'del-error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
      onSettled: () => {
        queryList.refetch();
      },
    },
  );

  const handleChange = useCallback(async () => {
    await changeMutator.mutate();
  }, [changeMutator]);

  const handleDelete = (id: number) => {
    deleteMutator.mutate(id);
  };

  const handleCloseModal = () => {
    setEditObject(null);
    setFieldErrors(null);
  };

  const handleOpenModalNewObject = () => {
    // Verificar se está no plano free tier
    if (capacidadesQuery.data?.freeTier) {
      setShowFreeTierModal(true);
      return;
    }

    setEditObject({});
  };

  const handleImportModal = () => {
    setShowImportModal(true);
    importMutator.reset();
  };

  const handleImportWhatsappModal = () => {
    setShowImportWhatsappModal(true);
    waImportMutator.reset();
    setWaImportResults(null);
  };

  const handleExportChatsModal = () => {
    setShowExportChatsModal(true);
    setExportMode('all');
    setSelectedClientesToExport([]);
  };

  const handleExportCSV = async () => {
    try {
      const filter: Record<string, any> = {};

      if (filterStatus.length > 0) {
        filter['estado'] = ['in', filterStatus];
      }

      if (filterClienteGrupo.length > 0) {
        filter['grupo_id'] = ['in', filterClienteGrupo.map(Number)];
      }

      const params = new URLSearchParams({
        txt: debouncedSearch,
        fi: JSON.stringify(filter),
      });

      const ids = searchParams.getAll('ids');
      if (ids.length > 0) {
        ids.forEach(id => params.append('ids', id));
      }

      const response = await axios.get(
        `/api/cliente/export/csv?${params.toString()}`,
        { responseType: 'blob', withCredentials: true },
      );

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `contatos-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast('Contatos exportados com sucesso!', {
        type: 'success',
        position: 'top-center',
      });
    } catch (error: any) {
      console.error('Erro ao exportar contatos:', error);
      toast(error.response?.data?.msg ?? 'Erro ao exportar contatos', {
        type: 'error',
        position: 'top-center',
      });
    }
  };

  // Query para buscar todos os clientes (apenas quando modo selecionado estiver ativo)
  const clientesQuery = useQuery(
    ['clientes-export', showExportChatsModal, exportMode],
    async () => {
      if (!showExportChatsModal || exportMode !== 'selected') return { result: [] };
      const { data } = await axios.get('/api/cliente', {
        params: { t: 10000 }, // Buscar muitos clientes
      });
      return data;
    },
    {
      enabled: showExportChatsModal && exportMode === 'selected',
      staleTime: 30000,
    }
  );

  const waImportMutator = useMutation(async () => {
    if (!waFiles || waFiles.length === 0) {
      alert('Nenhum arquivo selecionado.');
      return;
    }

    if (!waCanalId) {
      alert('Selecione o canal alvo.');
      return;
    }

    setWaImportResults(null);

    const formData = new FormData();
    waFiles.forEach(f => formData.append('files[]', f as Blob));
    formData.append('canal_id', String(waCanalId));

    try {
      const response = await axios.post(`/api/cliente/upload/whatsapp`, formData);
      setWaImportResults(response.data);
    } catch (error: any) {
      console.error(error);
      toast(error.response?.data?.msg ?? 'Erro ao importar arquivo', {
        toastId: 'wa-import-error',
        position: 'top-center',
        type: 'warning',
        autoClose: 5000,
      });
      throw error;
    } finally {
      setWaFiles([]);
    }
  });

  const handleWaImportStart = async () => {
    waImportMutator.mutate();
  };

  const handleWaFileChange = (files: File[]) => {
    setWaFiles(files);
  };

  const [editCustomizeObject, setEditCustomizeObject] =
    React.useState<any>(null);
  const [customizeFieldErrors, setCustomizeFieldErrors] = React.useState<Record<
    string,
    string
  > | null>(null);

  const customizeMutator = useMutation(
    async () => {
      if (!editCustomizeObject) return;

      setCustomizeFieldErrors(null);

      return await axios.post(`/api/cliente/meta`, editCustomizeObject, {
        withCredentials: true,
      });
    },
    {
      onSuccess: () => {
        handleCloseCustomizeModal();
        queryList.refetch();
        qCustomize.refetch();

        toast('Dados alterados com sucesso', {
          toastId: 'customize-success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: (err: any) => {
        if (err.response?.status === 422) {
          setCustomizeFieldErrors(err.response?.data?.fieldErrors ?? {});
        }
        toast(err.response?.data?.msg ?? 'Erro desconhecido', {
          toastId: 'customize-error',
          position: 'top-center',
          type: 'error',
          autoClose: 5000,
        });
      },
    },
  );

  const newCustomizeObj = () => ({
    nome: '',
    tipo: 'texto',
    valor_padrao: '',
    obrigatorio: false,
    filtravel: true,
    listavel: true,
  });

  const handleCustomizeModal = () => {
    setEditCustomizeObject(qCustomize.data ?? []);
    setShowCustomizeModal(true);
    customizeMutator.reset();
  };

  const handleCloseCustomizeModal = () => {
    setShowCustomizeModal(false);
    setEditCustomizeObject([]);
    setCustomizeFieldErrors(null);
  };

  const handleChangeCustomization = () => {
    customizeMutator.mutateAsync();
  };

  const queryFlatList =
    queryList.data?.pages?.map(p => p.data.result)?.flat() ?? [];
  const total =
    queryList.data?.pages?.[0]?.data?.total ?? 0;
  const editMode = !!editObject?.id && editObject.id > 0;

  const handleClientInfoClose = () => {
    setClientInfo(null);
    queryList.refetch();
  };
  return (
    <LayoutUsuario>
      <FreeTierModal
        show={showFreeTierModal}
        onClose={() => setShowFreeTierModal(false)}
        feature="o cadastro de novos contatos"
      />

      <Modal
        show={showImportWhatsappModal}
        title="Importar histórico (WhatsApp)"
        onClose={() => {
          setWaImportResults(null);
          setShowImportWhatsappModal(false);
        }}
        onConfirm={() => {
          setWaImportResults(null);
          waFormRef.current!.dispatchEvent(
            new Event('submit', { cancelable: true, bubbles: true }),
          );
        }}
        confirmProps={{
          label: 'Iniciar importação',
          disabled: waImportMutator.isLoading || (waFiles?.length ?? 0) === 0 || !waCanalId,
        }}
        cancelProps={{
          label: 'Fechar',
          disabled: waImportMutator.isLoading,
        }}
      >
        <VBox>
          <form
            ref={waFormRef}
            onSubmit={e => {
              e.preventDefault();
              handleWaImportStart();
            }}
          >
            <Grid>
              <GridItem sm={12}>
                {waImportMutator.isIdle ? (
                  <>
                    <p>Selecione o canal alvo e envie um ou mais arquivos ZIP exportados do WhatsApp.</p>
                    <p>Cada ZIP deve estar nomeado como "Conversa do WhatsApp com +55 XX XXXX-XXXX.zip" e conter um arquivo .txt com as mensagens.</p>
                  </>
                ) : waImportMutator.isLoading ? (
                  <AlertBox variant="info">
                    <p>Aguarde. Este processo pode levar alguns minutos.</p>
                    <p>Enquanto isto, por favor, não recarregue esta página.</p>
                  </AlertBox>
                ) : waImportMutator.isSuccess ? (
                  <>
                    <AlertBox variant="success">
                      <p style={{ textAlign: 'center', width: '100%' }}>
                        Importação concluída!
                      </p>
                      <p style={{ textAlign: 'center', width: '100%' }}>
                        Conversas: {waImportResults?.length?.conversas ?? 0} — Mensagens: {waImportResults?.length?.mensagens ?? 0}
                      </p>
                    </AlertBox>
                    {waImportResults?.erros?.length > 0 && (
                      <>
                        <p style={{ textAlign: 'center', width: '100%' }}>
                          Alguns arquivos não puderam ser processados:
                        </p>
                        <table style={{ width: '100%' }}>
                          <thead>
                            <tr>
                              <th style={{ textAlign: 'start' }}>Arquivo</th>
                              <th style={{ textAlign: 'start' }}>Erro</th>
                            </tr>
                          </thead>
                          <tbody>
                            {waImportResults?.erros?.map((it: any, idx: number) => (
                              <tr key={idx}>
                                <td>{it.arquivo}</td>
                                <td>{it.erro}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                ) : (
                  <AlertBox variant="warning">
                    <p>Ocorreu um erro ao tentar importar o arquivo.</p>
                  </AlertBox>
                )}
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoSeletor
                  label="Canal (WhatsApp/WA360)"
                  options={canaisWhatsapp}
                  value={waCanalId ?? undefined}
                  onChange={(v: any) => setWaCanalId(v)}
                  error={!waCanalId ? 'Campo necessário' : undefined}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <label>Arquivos (.zip)</label>
                <CampoUpload
                  accept=".zip"
                  value={waFiles}
                  onChange={handleWaFileChange}
                  disabled={waImportMutator.isLoading}
                  maxFiles={100}
                />
              </GridItem>
            </Grid>
          </form>
        </VBox>
      </Modal>

      {/* Modal de Exportação de Conversas */}
      <Modal
        title="Exportar conversas"
        show={showExportChatsModal}
        onClose={() => {
          stopExportPoll();
          setShowExportChatsModal(false);
          setExportMode('all');
          setSelectedClientesToExport([]);
          setExportJobId(null);
          setExportJobStatus('idle');
          setExportJobProgress(0);
          setExportJobError(null);
        }}
        onConfirm={async () => {
          if (exportJobStatus === 'pendente' || exportJobStatus === 'processando') return;

          try {
            const payload = exportMode === 'all'
              ? {}
              : { cliente_ids: selectedClientesToExport };

            setExportJobStatus('pendente');
            setExportJobProgress(0);
            setExportJobError(null);

            const { data } = await axios.post('/api/chat/export', payload);
            const jobId: number = data.job_id;
            setExportJobId(jobId);

            toast('Export iniciado! Acompanhe o progresso abaixo.', { type: 'info', position: 'top-center' });

            // Iniciar polling
            exportPollRef.current = setInterval(async () => {
              try {
                const { data: statusData } = await axios.get(`/api/chat/export/${jobId}/status`);
                setExportJobStatus(statusData.status);
                setExportJobProgress(statusData.progresso ?? 0);

                if (statusData.status === 'concluido') {
                  stopExportPoll();
                  await triggerExportDownload(jobId, statusData.filename);
                  setShowExportChatsModal(false);
                  setExportMode('all');
                  setSelectedClientesToExport([]);
                  setExportJobId(null);
                  setExportJobStatus('idle');
                  setExportJobProgress(0);
                } else if (statusData.status === 'erro') {
                  stopExportPoll();
                  setExportJobError(statusData.erro_mensagem ?? 'Erro ao exportar conversas');
                  toast(statusData.erro_mensagem ?? 'Erro ao exportar conversas', { type: 'error', position: 'top-center' });
                }
              } catch (err) {
                console.error('Erro ao verificar status do export:', err);
              }
            }, 3000);

          } catch (error: any) {
            console.error('Erro ao iniciar exportação:', error);
            setExportJobStatus('erro');
            setExportJobError(error.response?.data?.msg ?? 'Erro ao iniciar exportação');
            toast(error.response?.data?.msg ?? 'Erro ao iniciar exportação', { type: 'error', position: 'top-center' });
          }
        }}
        confirmProps={{
          label: exportJobStatus === 'idle' || exportJobStatus === 'erro' ? 'Exportar' : 'Exportando...',
          disabled: (
            (exportMode === 'selected' && (selectedClientesToExport.length === 0 || clientesQuery.isLoading)) ||
            exportJobStatus === 'pendente' ||
            exportJobStatus === 'processando'
          ),
        }}
        cancelProps={{
          label: 'Cancelar',
        }}
      >
        <VBox gap="16px">
          <VBox gap="12px">
            <label>
              <input
                type="radio"
                name="exportMode"
                value="all"
                checked={exportMode === 'all'}
                onChange={(e) => setExportMode(e.target.value as 'all' | 'selected')}
                style={{ marginRight: '8px' }}
              />
              Exportar todas as conversas
            </label>
            <label>
              <input
                type="radio"
                name="exportMode"
                value="selected"
                checked={exportMode === 'selected'}
                onChange={(e) => setExportMode(e.target.value as 'all' | 'selected')}
                style={{ marginRight: '8px' }}
              />
              Selecionar contatos para exportar
            </label>
          </VBox>

          {exportMode === 'selected' && (
            <>
              {clientesQuery.isLoading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Icon path={mdiLoading} size={1.5} spin={1} color="var(--tc-color-primary)" />
                  <p>Carregando contatos...</p>
                </div>
              ) : (
                <>
                  <CampoMultiSeletor
                    label="Selecione os contatos"
                    placeholder="Buscar contatos..."
                    options={(clientesQuery.data?.result || []).map((cliente: any) => ({
                      id: String(cliente.id),
                      label: cliente.nome,
                    }))}
                    value={selectedClientesToExport.map(String)}
                    onChange={(selected) => {
                      setSelectedClientesToExport(selected.map(Number));
                    }}
                  />

                  <HBox gap="8px" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: 'var(--tc-color-gray-600)', fontSize: '0.9rem' }}>
                      {selectedClientesToExport.length} de {clientesQuery.data?.result?.length || 0} contatos selecionados
                    </span>
                  </HBox>
                </>
              )}
            </>
          )}

          <AlertBox variant="info">
            <p>As conversas serão exportadas como arquivos ZIP no formato do WhatsApp.</p>
            <p>Cada conversa será um arquivo ZIP separado, contendo as mensagens em TXT e os arquivos de mídia.</p>
            {exportMode === 'all' && <p><strong>Todas as conversas de todos os canais serão exportadas.</strong></p>}
          </AlertBox>

          {exportJobStatus !== 'idle' && (
            <VBox gap="8px">
              {exportJobStatus === 'erro' ? (
                <AlertBox variant="warning">
                  <p><strong>Erro:</strong> {exportJobError ?? 'Falha ao exportar conversas.'}</p>
                </AlertBox>
              ) : exportJobStatus === 'concluido' ? (
                <AlertBox variant="success">
                  <p>Exportação concluída! O download será iniciado automaticamente.</p>
                </AlertBox>
              ) : (
                <AlertBox variant="info">
                  <p>
                    {exportJobStatus === 'pendente' ? 'Aguardando início do processamento...' : `Exportando conversas... ${exportJobProgress}%`}
                  </p>
                  <div style={{ width: '100%', height: '8px', background: 'var(--tc-color-gray-200)', borderRadius: '4px', overflow: 'hidden', marginTop: '8px' }}>
                    <div style={{ width: `${exportJobProgress}%`, height: '100%', background: 'var(--tc-color-primary)', borderRadius: '4px', transition: 'width 0.5s ease' }} />
                  </div>
                </AlertBox>
              )}
            </VBox>
          )}
        </VBox>
      </Modal>

      <Modal
        size="lg"
        ignoreOverlayClick
        title="Personalizar contatos"
        show={showCustomizeModal}
        onClose={handleCloseCustomizeModal}
        onCancel={handleCloseCustomizeModal}
        onConfirm={handleChangeCustomization}
      >
        <VBox>
          <HBox stretch>
            <p>Todos os contatos receberão os campos abaixo.</p>
            <Botao
              variant="outline-primary"
              icon={mdiPlus}
              onClick={() =>
                setEditCustomizeObject([
                  ...(editCustomizeObject ?? []),
                  newCustomizeObj(),
                ])
              }
            >
              Adicionar campo
            </Botao>
          </HBox>

          <table style={{ width: '100%' }}>
            <tr>
              <th>Rótulo</th>
              <th>Tipo</th>
              <th>Valor padrão</th>
              <th>Obrigatório?</th>
              <th>Filtrável?</th>
              <th>Listável?</th>
              <th>Ações</th>
            </tr>
            <tr>
              <td colSpan={7}>
                <hr />
              </td>
            </tr>
            {editCustomizeObject?.map((obj: any, idx: number) => (
              <tr>
                <td>
                  <CampoTexto
                    value={obj.rotulo}
                    onChange={v =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, rotulo: v } : it,
                        ),
                      )
                    }
                    error={customizeFieldErrors?.[`${idx}.rotulo`]}
                  />
                </td>
                <td>
                  <CampoSeletor
                    noSearch
                    options={[
                      { id: 'texto', label: 'Texto' },
                      { id: 'numero', label: 'Número' },
                      { id: 'data', label: 'Data' },
                      { id: 'booleano', label: 'Booleano' },
                      { id: 'lista', label: 'Lista' },
                    ]}
                    value={obj.tipo}
                    onChange={v =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, tipo: v } : it,
                        ),
                      )
                    }
                    error={customizeFieldErrors?.[`${idx}.tipo`]}
                  />
                </td>
                <td>
                  <CampoPersonalizacao
                    type={obj.tipo}
                    onTypeChanged={() =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, valor_padrao: null } : it,
                        ),
                      )
                    }
                    value={obj.valor_padrao}
                    onChange={(v: any) =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, valor_padrao: v } : it,
                        ),
                      )
                    }
                    error={customizeFieldErrors?.[`${idx}.valor_padrao`]}
                  />
                </td>
                <td>
                  <CampoCheckbox
                    value={obj.obrigatorio}
                    onChange={v =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, obrigatorio: v } : it,
                        ),
                      )
                    }
                    error={customizeFieldErrors?.[`${idx}.obrigatorio`]}
                  >
                    Obrigatório
                  </CampoCheckbox>
                </td>
                <td>
                  <CampoCheckbox
                    value={obj.filtravel}
                    onChange={v =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, filtravel: v } : it,
                        ),
                      )
                    }
                    error={customizeFieldErrors?.[`${idx}.filtravel`]}
                  >
                    Filtrável
                  </CampoCheckbox>
                </td>
                <td>
                  <CampoCheckbox
                    value={obj.listavel}
                    onChange={v =>
                      setEditCustomizeObject(
                        editCustomizeObject?.map((it: any, i: number) =>
                          i === idx ? { ...it, listavel: v } : it,
                        ),
                      )
                    }
                    error={customizeFieldErrors?.[`${idx}.listavel`]}
                  >
                    Listável
                  </CampoCheckbox>
                </td>
                <td>
                  <HBox style={{ justifyContent: 'flex-end' }}>
                    <BotaoPerigoso
                      variant="none-danger"
                      icon={mdiTrashCan}
                      onClick={() =>
                        setEditCustomizeObject(
                          editCustomizeObject?.filter(
                            (it: any, i: number) => i !== idx,
                          ),
                        )
                      }
                    />
                  </HBox>
                </td>
              </tr>
            ))}
          </table>
        </VBox>
      </Modal>

      <Modal
        instanceId='modal-cliente'
        ignoreOverlayClick
        title={editMode ? 'Editar contato' : 'Novo contato'}
        show={!!editObject}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onConfirm={handleChange}
      >
        <FormCliente
          value={editObject as any}
          onChange={setEditObject}
          fieldErrors={fieldErrors}
        />
      </Modal>

      <Modal
        //hideClose={importMutator.isLoading}
        show={showImportModal}
        title="Importar contatos"
        onClose={() => {
          setImportResults(null);
          setShowImportModal(false);
        }}
        onConfirm={() => {
          setImportResults(null);
          formRef.current!.dispatchEvent(
            new Event('submit', { cancelable: true, bubbles: true }),
          );
        }}
        confirmProps={{
          label: 'Iniciar importação',
          disabled:
            importMutator.isLoading ||
            !file ||
            !ddd?.length,
        }}
        cancelProps={{
          label: 'Fechar',
          disabled: importMutator.isLoading,
        }}
      >
        <VBox>
          <form
            ref={formRef}
            onSubmit={e => {
              e.preventDefault();
              handleImportStart();
            }}
          >
            <Grid>
              <GridItem sm={12} md={6}>
                <CampoNumero
                  label="DDD"
                  value={ddd ?? ''}
                  onChange={v => setDdd(v)}
                  disabled={importMutator.isLoading}
                  error={!ddd ? 'Campo necessário' : !/^\d\d$/.test(ddd) ? 'DDD inválido' : undefined}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoSeletor
                  noSearch
                  label="Estado padrão"
                  value={clienteEstado ?? undefined}
                  onChange={setClienteEstado}
                  //disabled={importMutator.isLoading}
                  options={[
                    { label: 'Ativo', id: 'ativo' },
                    { label: 'Bloqueado', id: 'bloqueado' },
                    {
                      label: 'Bloqueado (campanhas)',
                      id: 'bloqueado_campanha',
                    },
                  ]}
                  error={!clienteEstado ? 'Campo necessário' : undefined}
                />
              </GridItem>
              <GridItem sm={12}>
                <label>Arquivo</label>
                <CampoUpload
                  accept=".vcf,.csv"
                  value={file ? [file] : []}
                  onChange={handleFileChange}
                  disabled={importMutator.isLoading}
                />
              </GridItem>
            </Grid>
          </form>

          {importMutator.isIdle ? (
            <>
              <p>
                Para importar arquivos CSV, a primeira linha do arquivo deve
                conter o cabeçalho.
              </p>
              <p>
                Os campos reconhecidos são: <b>nome</b>, <b>empresa</b>,{' '}
                <b>telefone</b> e <b>email</b>
              </p>
              <p>Exemplo de conteúdo do arquivo CSV:</p>
              <pre
                style={{
                  border: '1px solid #DDD',
                  padding: '.5rem',
                  backgroundColor: '#EEE',
                }}
              >
                nome,telefone
                <br />
                João da Silva,11999998888
                <br />
                Maria da Silva,11999998888
                <br />
              </pre>
            </>
          ) : importMutator.isLoading ? (
            <AlertBox variant="info">
              <p>Aguarde. Este processo pode levar alguns minutos.</p>
              <p>Enquanto isto, por favor, não recarregue esta página.</p>
            </AlertBox>
          ) : importMutator.isSuccess ? (
            <>
              <AlertBox variant="success">
                <p style={{ textAlign: 'center', width: '100%' }}>
                  A importação foi concluída!
                </p>

                <p style={{ textAlign: 'center', width: '100%' }}>
                  Contatos importados: {importResults?.length?.success}
                </p>
              </AlertBox>

              {importResults?.length?.error > 0 && (
                <>
                  <p style={{ textAlign: 'center', width: '100%' }}>
                    Os seguintes contatos não puderam ser importados:
                  </p>

                  <table style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'start' }}>Nome</th>
                        <th style={{ textAlign: 'start' }}>Contato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importResults?.clientesErro?.map(
                        (cli: any, idx: number) => (
                          <tr key={idx}>
                            <td>{cli?.nome ?? '(vazio)'}</td>
                            <td>
                              {cli?.contatos?.map((c: any, idx1: number) => (
                                <div key={idx1}>
                                  <IconeCanal
                                    tipo={c?.tipo}
                                    style={{ height: '16px' }}
                                  />
                                  {c?.valor}
                                </div>
                              )) ?? '(vazio)'}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </>
              )}
            </>
          ) : importMutator.isError ? (
            <AlertBox variant="warning">
              <p>Ocorreu um erro ao tentar importar os arquivos.</p>

              <p>
                Tente novamente. Se o problema persistir, contate nosso suporte
                técnico.
              </p>
            </AlertBox>
          ) : (
            <AlertBox variant="warning">
              <p>Ocorreu um erro desconhecido.</p>

              <p>
                Tente novamente. Se o problema persistir, contate nosso suporte
                técnico.
              </p>
            </AlertBox>
          )}
        </VBox>
      </Modal>

      <Modal
        size="md"
        title="Dados do contato"
        show={Boolean(clientInfo)}
        hideControls
        onClose={handleClientInfoClose}
        onCancel={handleClientInfoClose}
        onConfirm={handleClientInfoClose}
      >
        <ViewCliente
          value={clientInfo}
          onEdit={id => {
            setClientInfo(null);
            setEditObject(queryFlatList.find(it => it.id === id));
          }}
          onViewChatMessages={id => {
            navigate(`/chat?uid=${id}`);
          }}
        />
      </Modal>

      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <HBox>
          <VBox>
            <Titulo>Contatos</Titulo>
            <Descricao>Gerencie aqui os contatos de seus clientes.</Descricao>
          </VBox>
          <HBox gap="12px" className={styles.headerAcoes}>

            {/* Desktop: Personalizar */}
            <div className={styles.desktopOnly}>
              <Botao
                variant="outline-secondary"
                icon={mdiStar}
                onClick={handleCustomizeModal}
              >
                Personalizar...
              </Botao>
            </div>

            {/* Desktop: Importar dropdown */}
            <div className={styles.desktopOnly}>
              <BotaoDropdown
                variant="outline-primary"
                icon={mdiDownload}
                text="Importar"
                dropdownStyle={{ width: 'auto', minWidth: '240px' }}
              >
                {({ closeDropdown }) => (
                  <VBox gap="0">
                    <button
                      className={styles.dropdownItem}
                      disabled={capacidadesQuery.data?.freeTier}
                      onClick={() => { closeDropdown(); handleImportModal(); }}
                    >
                      <Icon path={mdiDownload} size={0.8} />
                      <span>Importar contatos</span>
                    </button>
                    <button
                      className={styles.dropdownItem}
                      disabled={capacidadesQuery.data?.freeTier}
                      onClick={() => { closeDropdown(); handleImportWhatsappModal(); }}
                    >
                      <Icon path={mdiDownload} size={0.8} />
                      <span>Importar histórico (WhatsApp)</span>
                    </button>
                  </VBox>
                )}
              </BotaoDropdown>
            </div>

            {/* Desktop: Exportar dropdown */}
            <div className={styles.desktopOnly}>
              <BotaoDropdown
                variant="outline-primary"
                icon={mdiUpload}
                text="Exportar"
                dropdownStyle={{ width: 'auto', minWidth: '200px' }}
              >
                {({ closeDropdown }) => (
                  <VBox gap="0">
                    <button
                      className={styles.dropdownItem}
                      onClick={() => { closeDropdown(); handleExportCSV(); }}
                    >
                      <Icon path={mdiUpload} size={0.8} />
                      <span>Exportar CSV</span>
                    </button>
                    <button
                      className={styles.dropdownItem}
                      disabled={capacidadesQuery.data?.freeTier}
                      onClick={() => { closeDropdown(); handleExportChatsModal(); }}
                    >
                      <Icon path={mdiUpload} size={0.8} />
                      <span>Exportar conversas</span>
                    </button>
                  </VBox>
                )}
              </BotaoDropdown>
            </div>

            {/* Mobile: Mais ações dropdown */}
            <div className={styles.mobileOnly}>
              <BotaoDropdown
                variant="outline-primary"
                icon={mdiDotsVertical}
                text="Mais ações"
                dropdownStyle={{ width: 'auto', minWidth: '240px' }}
              >
                {({ closeDropdown }) => (
                  <VBox gap="0">
                    <button
                      className={styles.dropdownItem}
                      onClick={() => { closeDropdown(); handleCustomizeModal(); }}
                    >
                      <Icon path={mdiStar} size={0.8} />
                      <span>Personalizar...</span>
                    </button>
                    <button
                      className={styles.dropdownItem}
                      disabled={capacidadesQuery.data?.freeTier}
                      onClick={() => { closeDropdown(); handleImportModal(); }}
                    >
                      <Icon path={mdiDownload} size={0.8} />
                      <span>Importar contatos</span>
                    </button>
                    <button
                      className={styles.dropdownItem}
                      disabled={capacidadesQuery.data?.freeTier}
                      onClick={() => { closeDropdown(); handleImportWhatsappModal(); }}
                    >
                      <Icon path={mdiDownload} size={0.8} />
                      <span>Importar histórico (WhatsApp)</span>
                    </button>
                    <button
                      className={styles.dropdownItem}
                      onClick={() => { closeDropdown(); handleExportCSV(); }}
                    >
                      <Icon path={mdiUpload} size={0.8} />
                      <span>Exportar CSV</span>
                    </button>
                    <button
                      className={styles.dropdownItem}
                      disabled={capacidadesQuery.data?.freeTier}
                      onClick={() => { closeDropdown(); handleExportChatsModal(); }}
                    >
                      <Icon path={mdiUpload} size={0.8} />
                      <span>Exportar conversas</span>
                    </button>
                  </VBox>
                )}
              </BotaoDropdown>
            </div>

            {/* Novo contato - sempre visível */}
            <div>
              <Botao
                variant="primary"
                icon={mdiPlus}
                onClick={handleOpenModalNewObject}
              >
                Novo contato
              </Botao>
              {capacidadesQuery.data?.freeTier && (
                <div
                  style={{
                    marginLeft: '8px',
                    fontSize: '12px',
                    fontStyle: 'italic',
                    color: 'var(--tc-color-danger)',
                    textAlign: 'center',
                  }}
                >
                  Plano gratuito
                </div>
              )}
            </div>
          </HBox>
        </HBox>

        {/* Filtros */}
        <Grid>
          <GridItem sm={12} lg={6}>
            <CampoTexto
              prepend={
                <Icon
                  path={mdiMagnify}
                  size={1}
                  color="var(--tc-color-gray-500)"
                />
              }
              placeholder="Pesquisar"
              value={search}
              onChange={setSearch}
            />
          </GridItem>
          <GridItem sm={12} lg={3}>
            <CampoMultiSeletor
              placeholder="Filtrar por situação"
              options={[
                { id: 'ativo', label: 'Ativos' },
                {
                  id: 'bloqueado_campanha',
                  label: 'Bloqueados para campanhas',
                },
                { id: 'bloqueado', label: 'Bloqueados' },
              ]}
              value={filterStatus}
              onChange={setFilterStatus}
            />
          </GridItem>
          <GridItem sm={12} lg={3}>
            <CampoMultiSeletor
              placeholder="Filtrar por grupo"
              options={gruposOptions}
              value={filterClienteGrupo}
              onChange={setFilterClienteGrupo}
            />
          </GridItem>
        </Grid>

        <div>
          <Botao variant="primary" onClick={() => queryList.refetch()}>
            Aplicar
          </Botao>
        </div>

        {queryList.isFetching && (
          <div>
            Aguarde...{' '}
            <Icon
              path={mdiLoading}
              size={0.8}
              color="var(--tc-color-gray-700)"
              spin
            />
          </div>
        )}

        {searchParams.entries().map(([k, v]) => (
          <Badge key={k} variant="info" style={{ alignSelf: 'flex-start', padding: '4px 8px' }}>
            <span>{k}={v}</span>
            <Botao variant="none-info" onClick={() => {
              searchParams.delete(k);

              queryList.refetch();

              const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
              window.history.replaceState({}, '', newUrl);
            }}
              icon={mdiDeleteCircle}
            />
          </Badge>
        ))}

        {!queryList.isFetching && (
          <div>
            Exibindo {queryFlatList?.length ?? '0'} de {total ?? '0'}{' '}
            resultados.
          </div>
        )}

        <DataTable
          isLoading={queryList.isFetching}
          cabecalhos={headers}
          linhas={queryFlatList ?? []}
          hasMoreData={queryList.hasNextPage}
          onLoadMore={async () => queryList.fetchNextPage()}
        />
      </VBox>
    </LayoutUsuario>
  );
};

export default Page;
